/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {Component, ElementRef, Input} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {InputAccessor} from '../input-accessor';

@Component({
    selector: 'ui-switcher',
    template: require('./ui-switcher.html'),
    styles: [require('./ui-switcher.less')],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: UiSwitcher, multi: true}
    ],
})



export class UiSwitcher extends InputAccessor {

    @Input() originModel: boolean = false;
    @Input() animation: boolean = true;

    constructor(public elementRef: ElementRef) {
        super();
    }

    public prepareValueHook() {}
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-switcher/ui-switcher.ts